
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_zhy5b_101",
  "disabled": "awsui_disabled_8cbea_zhy5b_181",
  "selected": "awsui_selected_8cbea_zhy5b_189",
  "icon": "awsui_icon_8cbea_zhy5b_210",
  "with-text": "awsui_with-text_8cbea_zhy5b_214",
  "with-no-text": "awsui_with-no-text_8cbea_zhy5b_220",
  "root": "awsui_root_8cbea_zhy5b_229",
  "segment-part": "awsui_segment-part_8cbea_zhy5b_264",
  "select": "awsui_select_8cbea_zhy5b_189",
  "segment-count-2": "awsui_segment-count-2_8cbea_zhy5b_283",
  "segment-count-3": "awsui_segment-count-3_8cbea_zhy5b_287",
  "segment-count-4": "awsui_segment-count-4_8cbea_zhy5b_291",
  "segment-count-5": "awsui_segment-count-5_8cbea_zhy5b_295",
  "segment-count-6": "awsui_segment-count-6_8cbea_zhy5b_299",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_zhy5b_303"
};
  